import { Dropdown } from '../formcontrols/Dropdown'; 
import { DropdownMultiple } from '../formcontrols/DropdownMultiple'; 
import { Input } from '../formcontrols/Input'; 
import { Radiostyled } from '../formcontrols/Radiostyled'; 
import { Radio } from '../formcontrols/Radio'; 
import { Checkbox } from '../formcontrols/Checkbox'; 
import { MaskedInput } from '../formcontrols/MaskedInput'; 
import { ReadOnly } from '../formcontrols/ReadOnly'; 
import { Hidden } from '../formcontrols/Hidden'; 
import { LinkField } from '../formcontrols/LinkField'; 
import { PasswordInput } from '../formcontrols/Password';
import { Textarea } from '../formcontrols/Textarea';
import { StyledLinkBlocks } from '../formcontrols/StyledLinkBlocks';
import { RichTextEditor } from '../formcontrols/RichTextEditor';
import { FileUpload } from '../formcontrols/FileUpload';
import { DatePickerControl } from '../formcontrols/DatePicker';
import { ChooseLocation } from '../formcontrols/ChooseLocation';
import { Button } from '../formcontrols/Button';
import { Range } from '../formcontrols/Range';
import { Switch } from '../formcontrols/Switch';
import { EmailAddressList } from '../formcontrols/EmailAddressList';
import { QRCodeScanner } from '../formcontrols/QRCodeScanner';
import { ReCaptcha } from '../formcontrols/ReCaptcha';
import { CheckboxMultiple } from '../formcontrols/CheckboxMultiple';
import { DropdownMultiselect } from '../formcontrols/DropdownMultiselect';

export class FormControlsHelper {
    static getFormControlComponent(typeName: string) {
        const formControlComponentMap: { [key: string]: string } = {
            datepicker: 'DatePickerControl',
            dropdown: 'Dropdown',
            dropdownmultiple: 'DropdownMultiselect',
            radio: 'Radio',
            checkbox: 'Checkbox',
            checkboxMultiple: 'CheckboxMultiple',
            maskedtext: 'MaskedInput',
            readOnly: 'ReadOnly',
            hidden: 'Hidden',
            text: 'Input',
            link: 'LinkField',
            password: 'PasswordInput',
            textarea: 'Textarea',
            styledlinkblocks: 'StyledLinkBlocks',
            richtexteditor: 'RichTextEditor',
            fileupload: 'FileUpload',
            chooseLocation: 'ChooseLocation',
            button: 'Button',
            range: 'Range',
            emailaddresslist: 'EmailAddressList',
            switch: 'Switch',
            qrcodescanner: 'QRCodeScanner',
            'radio-styled': 'Radiostyled',
            reCaptchaV2Invisible: 'ReCaptcha',
            dropdownMultiselect: 'DropdownMultiselect',
        };
        
        return formControlComponentMap[typeName];
    }
}

export { 
    ChooseLocation, Dropdown, DropdownMultiple, Input, Radiostyled, 
    Radio, Checkbox, CheckboxMultiple, MaskedInput, ReadOnly, Hidden, LinkField,
    PasswordInput, Textarea, StyledLinkBlocks, RichTextEditor, 
    FileUpload, DatePickerControl, Button, Range,
    EmailAddressList, Switch, QRCodeScanner, ReCaptcha, DropdownMultiselect
};